export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const SUM_ITEM = "SUM_ITEM";
export const SUB_ITEM = "SUB_ITEM";
export const CHECKOUT = "CHECKOUT";
export const TOGGLE_CART = "TOGGLE_CART";
export const CART_SEQ = "CART_SEQ";